
import { createSlice } from "@reduxjs/toolkit";
import { getIncident } from "../reduxApi/incidentReduxApi";

const IncidentSlice = createSlice({
    name: 'incident',
    initialState: {
        status: 'idel',
        incident: [],
    },
    reducers: {
        deleteincidentAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.incident.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.incident.splice(index, 1);
                }
            });
        },
        updateincidentAction: (state, action) => {
            console.log("action", action.payload.ROWID)
            const index = state.incident.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.incident.splice(index, 1, action.payload)
    
            }
        },
        addincidentAction: (state, action) => {
            console.log("Adding incident:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.incident.unshift(temp);
           
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getIncident.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getIncident.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing Incident Data", action.payload)
                state.incident = action.payload.data.IncidentResp
;
            })
    }
})
export const { deleteincidentAction, updateincidentAction, addincidentAction } = IncidentSlice.actions
export default IncidentSlice.reducer